export const SET_PACKAGES = "SET_PACKAGES";
export const SET_SELECTED_PACKAGE = "SET_SELECTED_PACKAGE";
export const SET_CONSULTATION_ORDER = "SET_CONSULTATION_ORDER";
export const SET_CONSULTATION_REQUEST = "SET_CONSULTATION_REQUEST";
export const SET_CONSULTATION_REQUESTS = "SET_CONSULTATION_REQUESTS";
